import { createContext, useContext } from "react"

// =============================================================================
// Context
// =============================================================================
// Base UI's `Field.Error` only follows native validity and its own `Form`, and
// Base UI keeps the label's id internal, so `Field` shares both itself.
export type FieldContextValue = {
  /** Whether the surrounding `Field` is `invalid`, which `Field.Error` shows on */
  invalid: boolean
  /**
   * The id the nearest `Field.Label` renders with, so a control's own parts
   * (a clear button) can name themselves after the field. A `Field.Item` has
   * its own, since each option in a group carries its own label.
   */
  labelId: string | undefined
  /**
   * Whether the `Field` is disabled, for a control's parts that sit in a field
   * of their own, which a parent field's `disabled` doesn't reach
   */
  disabled: boolean
}

export const FieldContext = createContext<FieldContextValue>({
  invalid: false,
  labelId: undefined,
  disabled: false
})

export function useFieldContext(): FieldContextValue {
  return useContext(FieldContext)
}
